import request from '@/utils/request'
import requestPublic from '@/utils/requestPublic'
import requests1 from '@/utils/commons'

export function getUuid() {
    return requestPublic({
        url: '/web/uuid/getUuid',
        method: 'get'
    })
}

// 获取验证码
// export function getPhoneCode(phone) {
//     return request({
//         url: `/api/login/send/${phone}`,
//         method: "get",
//     });
// }
export function getPhoneCode(data) {
    return requestPublic({
        url: `/webApi/sendSmsMessage`,
        method: "post",
        data: data
    });
}

//用户登录操作
export function loginIn(data) {
    return requestPublic({
        url: '/web/user/login',
        method: 'post',
        data: data
    })
}

// 获取SM2公钥（用于登录密码加密）
export function getSm2Key() {
    return requests1({
        url: '/web/sm2/getSm2Key',
        method: 'get',
    })
}


//用户登出操作
export function logOut(data) {
    return request({
        url: '/web/user/logout',
        method: 'put',
        data: data
    })
}


//更换绑定的手机号
// PUT http://localhost:1012/web/user/switchingBinding
export function switchingBinding(data) {
    return request({
        url: '/web/user/switchingBinding',
        method: 'put',
        data: data
    })
}


// GET http://localhost:1012/web/user/existenceOrNot/{{ldGx007a}}
//获取验证码之前先校验当前手机号是否已注册
export function existenceOrNot(data) {
    return requestPublic({
        url: '/web/user/existenceOrNot/'+data,
        method: 'get',
    })
}

export function wechatLoginLog(id) {
    return requestPublic({
        url: '/web/wechatLoginLog/'+id,
        method: 'get',
    })
}
//电子社保卡连接获取
export function getsbklogin(data) {
    return requestPublic({
        url: '/web/dzsbk/getFiveQrCode',
        method: 'post',
        data
    })
}

//电子社保卡登录
export function sbktoken(id) {
    return requestPublic({
        url: '/web/dzsbk/queryFiveQrCode/'+id,
        method: 'get',
    })
}

//登录
export function sbklogins(data) {
    return requestPublic({
        url: '/web/dzsbk/login',
        method: 'PUT',
        data
    })
}

// 根据用户名获取脱敏手机号
export function getMobile(data) {
    return requestPublic({
        url: '/system/user/getMobile',
        method: 'get',
        params: data
    });
}

// 登录前置校验（滑块验证通过后调用）
export function beforeLogin(data) {
    return requestPublic({
        url: '/web/user/beforeLogin',
        method: 'post',
        data: data
    });
}

// 校验管理人员秘钥（系统在建状态进入校验）
// sm2PublicKey：调用方已获取的公钥，透传给请求拦截器放入请求头，保证与加密所用公钥一致
export function validSecurity(data, sm2PublicKey) {
    return requestPublic({
        url: '/ldgx/security/valid',
        method: 'post',
        data: data,
        sm2PublicKey: sm2PublicKey
    });
}

// 获取手机短信验证码（用于登录二次验证，后端根据 userName 查找真实手机号）
export function getPhoneCode1(data) {
    return requestPublic({
        url: '/webApi/sendSmsMessageb',
        //  url: '/web/user/sendSmsMessageb',
        method: 'post',
        data: data
    });
}
